import { AxiosResponse } from 'axios';

import axiosInstance from 'api/base';
import { normalizeBaseGist, normalizePageData } from 'utils/commonNormalizer';
import { normalizeSearchFiltersPayload } from 'utils/filters';
import { IAllPageFilters, IBaseGist, IGroupEditPayload, IPageType } from 'utils/types';

import { prepareFormData } from '../../utils/form';

import { normalizeCashierSettings } from './normalizers';
import {
  ICashierSettings,
  ICashierSettingsData,
  ICashierSettingsForm,
  IEditCashierSettingPayload,
} from './types';

const cashierSettingsApi = {
  async getAllCashierSettings(
    filters: IAllPageFilters,
  ): Promise<IPageType<ICashierSettings>> {
    const normalizedFilter = normalizeSearchFiltersPayload(filters);

    const response = await axiosInstance.get('cashier-settings', {
      params: normalizedFilter,
    });

    return normalizePageData<ICashierSettingsData, ICashierSettings>(
      response.data,
      normalizeCashierSettings,
      JSON.stringify(filters.search),
    );
  },

  async getCashierSetting(id: string): Promise<ICashierSettings> {
    const response = await axiosInstance.get(`cashier-settings/${id}`);

    return normalizeCashierSettings(response?.data);
  },

  async createCashierSetting(payload: ICashierSettingsForm): Promise<IBaseGist> {
    const normalizedCashierSetting = prepareFormData(payload);
    const result = await axiosInstance.post(`cashier-settings`, normalizedCashierSetting);
    return normalizeBaseGist(result?.data);
  },

  async updateCashierSetting({
    id,
    payload,
  }: IEditCashierSettingPayload): Promise<IBaseGist> {
    const normalizedPayload = prepareFormData(payload);
    const result = await axiosInstance.put(`cashier-settings/${id}`, normalizedPayload);
    return normalizeBaseGist(result?.data);
  },

  async deleteCashierSetting(id: number | string): Promise<AxiosResponse> {
    const response = await axiosInstance.delete(`cashier-settings/${id}`);

    return response.data;
  },

  async groupEditCashierSettings({
    filters,
    settings,
  }: IGroupEditPayload): Promise<AxiosResponse> {
    const { search } = normalizeSearchFiltersPayload(filters);

    const response = await axiosInstance.patch('cashier-settings', settings, {
      params: { search },
    });

    return response;
  },
};

export default cashierSettingsApi;
